var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page f-col-ac light"},[_c('div',{staticClass:"f-grow"}),_c('img',{staticClass:"logo my-4",attrs:{"src":require("@/assets/text_logo.svg")}}),_c('h1',{},[_vm._v("Map Not Found!")]),_c('img',{staticClass:"image my-4",attrs:{"src":require("@/assets/map_not_exist.svg")}}),_c('div',{staticClass:"f-grow"}),_c('div',{staticClass:"f-grow"})])
}]

export { render, staticRenderFns }